import { getCurrentUser } from "aws-amplify/auth";

export interface StructuredDefinition {
  id: string;
  name: string;
  json: string;
  description?: string;
}

/**
 * 認証ヘッダーを取得
 */
const getAuthHeaders = async (): Promise<Record<string, string>> => {
  try {
    await getCurrentUser(); // ユーザーが存在することを確認
    const { fetchAuthSession } = await import("aws-amplify/auth");
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();
    
    if (idToken) {
      console.log("🔐 structured-definitions.ts - idToken取得成功");
      return {
        "Content-Type": "application/json",
        "Authorization": idToken,
      };
    } else {
      console.warn("🔐 structured-definitions.ts - idToken取得失敗");
      return {
        "Content-Type": "application/json",
      };
    }
  } catch (error) {
    console.error("🔐 structured-definitions.ts - 認証ヘッダー取得エラー:", error);
    return {
      "Content-Type": "application/json",
    };
  }
};

export const getStructuredDefinitions = async (): Promise<
  StructuredDefinition[]
> => {
  try {
    const headers = await getAuthHeaders();
    console.log("🔐 structured-definitions.ts - リクエストヘッダー:", headers);
    console.log("🔐 structured-definitions.ts - Authorizationヘッダー存在:", !!headers.Authorization);
    console.log("🔐 structured-definitions.ts - Authorizationヘッダー長さ:", headers.Authorization?.length || 0);

    const response = await fetch("/api/structured-definitions", {
      method: "GET",
      headers,
    });

    console.log("🔐 structured-definitions.ts - レスポンスステータス:", response.status);
    console.log("🔐 structured-definitions.ts - レスポンスヘッダー:", Object.fromEntries(response.headers.entries()));

    if (!response.ok) {
      if (response.status === 404) {
        console.info(
          "構造定義データが見つかりませんでした。空のリストを返します。"
        );
        return [];
      }
      throw new Error("構造定義情報の取得に失敗しました");
    }

    const result = await response.json();

    if (result.error) {
      console.warn("API側でエラーが発生しました:", result.error);
      return [];
    }

    return Array.isArray(result.data) ? result.data : [];
  } catch (error) {
    console.error("構造定義情報の取得エラー:", error);

    if (error instanceof TypeError) {
      console.warn(
        "ネットワークエラーまたはAPIが利用できません。空のリストを返します。"
      );
      return [];
    }

    console.warn(
      "構造定義の取得に失敗しましたが、アプリケーションを継続します。"
    );
    return [];
  }
};
